/*
 * UGRID minimum order (cart page + cart drawer).
 * The server render (snippets/cart-summary.liquid) uses fallback rates from theme settings.
 * Here the threshold is recomputed with the live Shopify conversion rate (window.Shopify.currency.rate),
 * and the checkout button / express checkout buttons are kept disabled/hidden while below the minimum.
 */
(function () {
  if (window.customElements.get('ugrid-min-order')) return;

  function decimalsFor(currency) {
    try {
      return new Intl.NumberFormat('en', { style: 'currency', currency: currency }).resolvedOptions()
        .maximumFractionDigits;
    } catch (e) {
      return 2;
    }
  }

  function format(minorUnits, currency, locale) {
    // Shopify Liquid/cart amounts are always value x 100, also for zero-decimal currencies (e.g. JPY).
    var value = minorUnits / 100;
    try {
      return new Intl.NumberFormat(locale || 'en', {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: decimalsFor(currency),
      }).format(value) + ' ' + currency;
    } catch (e) {
      return value.toFixed(2) + ' ' + currency;
    }
  }

  class UgridMinOrder extends HTMLElement {
    static get observedAttributes() {
      return ['data-total', 'data-threshold', 'data-currency'];
    }

    connectedCallback() {
      this.apply();
      var ctas = this.ctas();
      if (ctas && !this._observer) {
        var self = this;
        this._observer = new MutationObserver(function () {
          self.syncButtons();
        });
        this._observer.observe(ctas, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'hidden'] });
      }
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      this._observer = null;
    }

    attributeChangedCallback() {
      if (this.isConnected) this.apply();
    }

    ctas() {
      var el = this.nextElementSibling;
      while (el && !el.classList.contains('cart__ctas')) el = el.nextElementSibling;
      return el;
    }

    liveThreshold() {
      var d = this.dataset;
      var base = Number(d.minBase);
      if (d.currency === d.shopCurrency) return base;
      var sc = window.Shopify && window.Shopify.currency;
      if (sc && sc.active === d.currency && Number(sc.rate) > 0) {
        return Math.ceil((base * Number(sc.rate)) / 100) * 100;
      }
      return Number(d.threshold);
    }

    apply() {
      var d = this.dataset;
      var total = Number(d.total);
      var threshold = this.liveThreshold();
      this.below = total < threshold;

      // Only rewrite the server-rendered text when the live rate changed the threshold.
      if (threshold !== Number(d.threshold)) {
        var minLabel = d.shopCurrency + ' ' + d.minUsd;
        if (d.currency !== d.shopCurrency) minLabel += ' (≈ ' + format(threshold, d.currency, d.locale) + ')';
        var text = this.querySelector('.cart-min-order__text');
        var tpl = this.below ? d.msgBelow : d.msgMet;
        if (text && tpl) {
          var html = tpl.replace('__MIN__', minLabel);
          if (this.below) html = html.replace('__AMT__', format(threshold - total, d.currency, d.locale));
          if (text.innerHTML !== html) text.innerHTML = html;
        }
      }

      this.classList.toggle('cart-min-order--below', this.below);
      this.classList.toggle('cart-min-order--met', !this.below);
      var fill = this.querySelector('.cart-min-order__fill');
      if (fill) {
        var pct = this.below ? Math.floor((total * 100) / threshold) : 100;
        if (fill.style.width !== pct + '%') fill.style.width = pct + '%';
      }
      this.syncButtons();
    }

    syncButtons() {
      var ctas = this.ctas();
      if (!ctas || this.below === undefined) return;
      var btn = ctas.querySelector('.cart__checkout-button');
      if (btn && this.below && !btn.disabled) btn.disabled = true;
      if (btn && !this.below && btn.disabled && Number(this.dataset.total) > 0) btn.disabled = false;
      var extra = ctas.querySelector('.additional-checkout-buttons');
      if (extra && extra.hidden !== this.below) extra.hidden = this.below;
    }
  }

  window.customElements.define('ugrid-min-order', UgridMinOrder);

  // Block form submission to checkout while below the minimum (e.g. Enter key or a re-enabled button).
  document.addEventListener(
    'submit',
    function (event) {
      var submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      var widgets = document.querySelectorAll('ugrid-min-order');
      for (var i = 0; i < widgets.length; i++) {
        if (widgets[i].below) {
          event.preventDefault();
          event.stopPropagation();
          widgets[i].scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
      }
    },
    true
  );
})();
